import { render } from "./AssetManagement.vue?vue&type=template&id=11332d6e&scoped=true"
import script from "./AssetManagement.vue?vue&type=script&lang=js"
export * from "./AssetManagement.vue?vue&type=script&lang=js"

import "./AssetManagement.vue?vue&type=style&index=0&id=11332d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11332d6e"]])

export default __exports__